module.exports = __webpack_public_path__ + "img/applied_job_logo_1.96cd9bde.png";